import styled from 'styled-components'
import { bp } from 'lib/core/resources/helpers/styled'
import CaretSvg from 'resources/svg/icons/caret-right.svg'
import { buttonGreen, buttonSizeLg, heading1 } from 'app/sofia/resources/theme/css'
import { containerCss } from 'app/sofia/components/Structure/Container'
import { BP } from 'resources/constants'

export const SliderWrapper = styled.div`
  .carousel {
    &__inner-slide {
      img {
        width: 100%;
      }
    }

    &__arrows {
      button {
        width: 44px;
        height: 52px;
        background: ${props => props.theme.palette.general.light};
        box-shadow: 0 3px 6px rgba(0, 0, 0, 0.29);
        justify-content: center;
        margin: 0 10px;

        svg {
          width: 20px;
          height: 40px;
        }
      }
    }
  }
`

export const SlideWrapper = styled.div`
  position: relative;

  .show {
    &-desktop {
      display: none;
      ${bp('sm', 'min-width')`
        display: block;
      `}
    }

    &-mobile {
      display: block;
      ${bp('sm', 'min-width')`
        display: none;
      `}
    }
  }

  .container {
    ${containerCss};
    margin-bottom: 40px;
    ${bp('sm', 'min-width')`
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      display: flex;
      align-items: center;
      justify-content: flex-end;
  `}

    .text-box {
      text-align: center;
      margin-top: -5px;

      p,
      h2 {
        span {
          color: ${props => props.theme.palette.general.red};
        }
      }

      ${bp('sm', 'min-width')`
        margin: 0;
        width: 40%;
        text-align: left;
      `}

      .product {
        ${bp('sm', 'min-width')`
          display: flex;
          align-items: flex-end;
        `}

        img {
          width: 10vw;
          margin-right: 15px;
          ${bp('sm')`
            position: absolute;
            top: 10px;
            right: 15px;
            width: 38vw;
          `}
        }

        a {
          text-decoration: none;
          color: ${props => props.theme.palette.general.strong};
        }

        h2 {
          ${heading1};
          margin-bottom: 0;
          ${bp('sm')`
            margin-top: 5px;
          `}

          &.show-mobile {
            ${bp('sm', 'min-width')`
              display: none;
            `}
          }
        }
      }

      h1 {
        ${heading1};

        br {
          display: none;
          ${bp('sm', 'min-width')`
            display: block;
          `}
        }
      }

      p {
        font-size: 15px;
        line-height: 1.4;
        margin: 0 0 20px;
        ${bp('sm', 'min-width')`
          font-size: 16px;
          margin: 0 0 25px;
        `}

        @media (min-width: ${BP.lg.min}) {
          font-size: 17px;
        }
      }

      .btn {
        ${buttonGreen};
        font-family: ${props => props.theme.font.alt.family};
        padding: 0 50px;

        @media (min-width: ${BP.md.min}) {
          ${buttonSizeLg}
        }

        > span {
          line-height: 1.5;
        }

        &::after {
          content: '';
          margin-left: 12px;
          width: 11px;
          height: 16px;
          background: url(${CaretSvg}) no-repeat center;
          background-size: 8px;
          filter: invert(100%) sepia(1%) saturate(7494%) hue-rotate(273deg) brightness(103%) contrast(97%);
          display: inline-block;
        }
      }
    }
  }
`
